module.exports = __webpack_public_path__ + "img/dog.78c2bd1e.svg";